import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import ErrorMessage from './ErrorMessage';
import LoadingMessage from './Loading';
import { useAuthStore } from '../store/AuthContext';
import { StylesSwapHelper } from '../utils/StylesSwapHelper';
import { StorageHelper } from '../utils/StorageHelper';

const Layout: FC = ({ children }) => {
  const history = useHistory();
  const dataUser = useAuthStore();
  const isApp = dataUser.user.isApp === 'true';
  const isEcommerceBot = StorageHelper.isEcommerceBot();

  StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);

  useEffect(() => {
    if (history) {
      history.listen((location) => {
        if (!location.pathname.includes('revista')) {
          sessionStorage.setItem('yearRevistas', '0');
          sessionStorage.setItem('revistaSelect', 'no-select');
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);
  // const location = useLocation() || ``;

  // useEffect(() => {
  //   DataService.accessData({}).then((r) => console.log(r));
  //   console.log('La ruta ha cambiado:', location.pathname);
  // }, [location]);
  return (
    <>
      <Header />
      <ErrorMessage />
      <LoadingMessage />
      <main>{children}</main>
      <Footer />
    </>
  );
};
export default Layout;
